import { tTemplate, tTemplateV2 } from './Agenda.types';

export function templateLegacyParser(
  template: tTemplateV2,
  workspaceId: string,
): tTemplate {
  return {
    id: template.id,
    workspace_id: workspaceId,
    event_type: template.eventType,
    name: template.name,
    emoji: template.emoji,
    reminder: template.reminder,
    reminder_time_minutes: template.reminderTimeMinutes,
    created_by: template.creatorAuthID,
    fields: template.fields,
  };
}
